var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSniperText = function SvgSniperText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sniper-text_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.648.027h23.22v23.946H.649z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#sniper-text_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sniper-text_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.758 10.817h-7.574A3.1 3.1 0 0 0 14.05 9.37a2.9 2.9 0 0 0-.835-.409 3 3 0 0 0-.919-.14q-.47 0-.918.14-.449.136-.835.409-.386.266-.677.635c-.193.249-.344.517-.453.812H5.565q.159-1.02.612-1.95A6.93 6.93 0 0 1 8.917 5.9a6.93 6.93 0 0 1 3.924-.96 7 7 0 0 1 1.999.408 6.99 6.99 0 0 1 3.243 2.415c.09.125.208.227.34.31q.205.12.438.155.234.034.461-.023.233-.055.42-.196a1.185 1.185 0 0 0 .25-1.663 9.3 9.3 0 0 0-2.828-2.521 9.25 9.25 0 0 0-3.59-1.206V1.274c0-.155-.03-.31-.09-.454a1.1 1.1 0 0 0-.258-.385 1.184 1.184 0 0 0-1.682 0Q11.38.6 11.287.82a1.2 1.2 0 0 0-.09.454v1.36q-.765.108-1.501.34a9.326 9.326 0 0 0-2.74 1.376 9.5 9.5 0 0 0-2.147 2.192q-.444.63-.775 1.327a9.2 9.2 0 0 0-.858 2.944H1.831a1.189 1.189 0 0 0-.843 2.03q.17.17.386.26.22.091.457.091h7.657q.378.827 1.142 1.32a3 3 0 0 0 1.67.495c.609 0 1.164-.167 1.674-.496q.765-.491 1.138-1.319h4.263c-.525 3.277-3.363 5.711-6.897 5.711a6.86 6.86 0 0 1-3.092-.714 6.9 6.9 0 0 1-2.449-2.01 1.18 1.18 0 0 0-.79-.454 1.186 1.186 0 0 0-1.3 1.489q.062.226.208.415a9.2 9.2 0 0 0 2.717 2.39 9.2 9.2 0 0 0 3.425 1.17v1.361a1.189 1.189 0 1 0 2.377 0v-1.33c4.346-.48 7.695-3.764 8.197-8.028h.987a1.189 1.189 0 0 0 .457-2.286 1.3 1.3 0 0 0-.457-.087z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sniper-text_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.648.087v23.656h23.22V.087z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m44.906 19.726 2.362-2.363V11.93l-2.362-2.363H35.34V6.97h11.928V3.19H33.922L31.56 5.553v5.43l2.362 2.363h9.566v2.6H31.56v3.78zM67.2 19.726V3.19h-3.78v10.156L56.096 3.19h-5.552v3.78h1.772v12.756h3.78V9.593l7.324 10.133zM75.32 19.726V3.19h-3.78v16.536zM92.893 15.708l2.362-2.362V5.553L92.893 3.19H78.6v3.78h12.877v4.959H84.15v-3.78h-3.78v11.577h3.78v-4.018zM114.241 19.726v-3.78H103.61v-2.6h8.269v-3.78h-8.269V6.97h10.631V3.19H98.058v3.78h1.772v12.756zM131.811 15.708l2.362-2.362V5.553l-2.362-2.363h-14.294v3.78h12.876v4.959h-7.324v-3.78h-3.78v11.577h3.78v-4.018h3.946c1.179 1.35 2.339 2.695 3.545 4.018h4.792c-1.202-1.323-2.362-2.669-3.541-4.018"
  })));
};
export default SvgSniperText;